// AA smart contract deployment
const SMART_ACCOUNT_FACTORY_ADDRESS = '0x9B947df68D35281C972511B3E7BC875926f26C1A';
// AA wallet validator contract deployment
const EOA_VALIDATOR_ADDRESS = '0x74b9ae28EC45E3FA11533c7954752597C3De3e7A';
const SESSION_KEY_VALIDATOR_ADDRESS = '0x34ca1501FAE231cC2ebc995CE013Dbe882d7d081';
const CONTRACT_DEPLOYER_ADDRESS = '0x0000000000000000000000000000000000008006';
const AGW_REGISTRY_ADDRESS = '0xd5E3efDA6bB5aB545cc2358796E96D9033496Dda';
const INSUFFICIENT_BALANCE_SELECTOR = '0xe7931438';
export { AGW_REGISTRY_ADDRESS, CONTRACT_DEPLOYER_ADDRESS, EOA_VALIDATOR_ADDRESS, INSUFFICIENT_BALANCE_SELECTOR, SESSION_KEY_VALIDATOR_ADDRESS, SMART_ACCOUNT_FACTORY_ADDRESS, };
//# sourceMappingURL=constants.js.map